"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation createOrder($params: OrderInput!) {
    createOrder(params: $params) {
      _id
      userId
      orgId
      eventId
      createdAt
      stripeChargeId
      feeIds
      tickets {
        _id
        name
        ticketTypeId
        ticketTierId
        price
        origionalPrice
        seat
        refund {
          refunded
          refundedAt
          refundedBy
          refundedAmount
        }
        scan {
          scanned
          scannedAt
          scannedBy
        }
        values
      }
      upgrades {
        _id
        name
        upgradeId
        price
        refund {
          refunded
          refundedAt
          refundedBy
          refundedAmount
        }
        scan {
          scanned
          scannedAt
          scannedBy
        }
      }
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=createOrder.mutation.js.map